var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DatePicker } from '@material-ui/pickers';
import { useForm } from '../hooks';
import FormDateTextField from './FormDateTextField';
var FormDate = function (_a) {
    var id = _a.id, description = _a.description, yearOnly = _a.yearOnly, rest = __rest(_a, ["id", "description", "yearOnly"]);
    var form = useForm();
    var value = useMemo(function () { return form.values[id]; }, [form.values[id]]);
    var handleDateChange = function (date) {
        form.setFieldValue(id, date);
    };
    return (_jsx(DatePicker, __assign({ format: yearOnly ? "yyyy" : "dd/MM/yyyy", views: yearOnly ? ["year"] : ["year", "month", "date"], value: value, onChange: handleDateChange, InputProps: { id: id, name: description }, TextFieldComponent: FormDateTextField }, rest), void 0));
};
export default FormDate;
//# sourceMappingURL=FormDate.js.map